import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from "./Grid";
import HeaderGrid from "./HeaderGrid";

import moment from 'moment'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Search from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import * as RemittanceDetail from './Saga/RemittanceDetail';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import RentMoney from '../RentMoney/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    // get_rent_contract_accounting:any,
    get_remittance_details: any,
    minories: any,
    search_detail: any,
    classes: any,
    search_loading: boolean,
    get_bklist: any,
    bklist: any,
    addky: any,
    delky: any,
}



interface State {
    toggle: boolean,
    // state types
}


const styles = ((theme: any) => ({

    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}))



class CustomerList extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);
        // this.props.change_search_name("")
        this.state = {
            toggle: false
        }

    }
    componentWillMount() {
        // this.props.get_owner_remittance_check_logs()
        // this.props.get_remittance_details()

        this.props.get_bklist()
        // this.props.get_rent_contracts()
        // this.props.customerNewDispSet(0)
        this.submit = this.submit.bind(this);

        this.toggle = this.toggle.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    submit(state: any) {
        console.log(state)

        this.props.get_remittance_details(state)
    }

    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    toggle() {
        this.setState({ toggle: !this.state.toggle })
        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12"

                //  style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    {/* {this.props.search_detail.contractor}   {this.props.search_detail.tatemono_name + this.props.search_detail.room_name}　 {moment(this.props.search_detail.start_at).format("YYYY/MM/DD")}～{moment(this.props.search_detail.end_at).format("YYYY/MM/DD")}
                    {this.props.search_detail.corse} */}

                    <Card >
                        <CardContent>
                            <Search />
                        </CardContent>
                    </Card>

                </div>


                {/* <div className="item-outer col-lg-12" style={{ display: (this.props.customerNewDisp === 1) ? '' : 'none' }}>
                    <div className="item">
           
                    </div>
                </div> */}
                {/* <div
                    style={{ paddingRight: 5, margin: 5 }}
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                > */}
                <Card className="col-lg-12">
                    <CardContent style={{ float: "left" }} className="col-lg-3">
                        <HeaderGrid />
                    </CardContent>
                    {/* </Card> */}
                    {/* </div>

                <div className="item-outer col-lg-9"
                    style={{ paddingLeft: 5 }}
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                > */}
                    {/* <Card > */}
                    <CardContent style={{ float: "left" }} className="col-lg-9">
                        {/* {this.props.addky.map(function (value: any) {
                            return value.hy_no + " " + value.kys_name
                        })}

                        {this.props.delky.map(function (value: any) {
                            return value.hy_no + " " + value.kys_name
                        })} */}
                        <Grid toggle={this.toggle} />
                    </CardContent>
                </Card>
                {/* </div> */}
                <Backdrop className={this.props.classes.backdrop} open={this.props.search_loading} >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Modal isOpen={this.state.toggle} toggle={this.toggle} size="xl" fade={false}>

                    <ModalHeader toggle={this.toggle}>入金確認</ModalHeader>
                    {/* <ModalBody> */}
                    <RentMoney />
                    {/* </ModalBody> */}
                    <ModalFooter>
                        {/* <button className="btn btn btn-danger" style={{margin:"5px"}} onClick={this.delete_introductions}>削除する</button>*/}
                        {/* <button className="btn btn btn-secondary" style={{ margin: "5px" }} onClick={() => this.props.change_search_modal(false)}>キャンセル</button> */}
                    </ModalFooter>
                </Modal >
            </div>
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
        search_loading: state.ContractCheck.search_loading,
        minories: state.Minori.minories,
        bklist: state.RemittanceDetail.bklist,
        addky: state.RemittanceDetail.addky,
        delky: state.RemittanceDetail.delky,


    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        get_bklist(state: any) {
            dispatch(RemittanceDetail.get_bklist(state))
        },
        // customerNewDispSet(state:number) {
        //     dispatch(customerNewDispSet(state))
        // },
        get_remittance_details(state: any) {
            dispatch(RemittanceDetail.get_remittance_details(state))
        },
        // get_owner_remittance_check_logs(state: any) {
        //     dispatch(RemittanceLogCheck.get_owner_remittance_check_logs(state))
        // },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CustomerList));




